import React from "react";
import ENV from "../../../config"; // Adjust the import path as needed

type SendToDataLayerProps = {
  googleTagClickId: any;
  dlvEventName: any;
  children: React.ReactNode;
};

// This component can be wrapped around a button or div in order to send
// an id and event name to the dataLayer, GTM uses this data to track clicks
const GoogleTagDataLayer: React.FC<SendToDataLayerProps> = ({
  googleTagClickId,
  dlvEventName,
  children,
}) => {
  const handleClick = (event: React.MouseEvent) => {
    if (ENV.PRODUCTION === "TRUE") {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: dlvEventName,
          clickID: googleTagClickId,
        });
      } else {
        console.error("dataLayer is not defined");
      }
    }

    if (
      React.isValidElement(children) &&
      typeof children.props.onClick === "function"
    ) {
      children.props.onClick(event);
    }
  };

  return React.cloneElement(children as React.ReactElement, {
    onClick: handleClick,
  });
};

export default GoogleTagDataLayer;
